import "../assets/NcCheckboxRadioSwitch-mgKotCbU.css";
import { r } from "./_l10n-gZppkly8.mjs";
r();
